import { _ } from "~/i18n";
import GPSSWitchVisualizer from "~/ui/gpsswitch/visualizer";
import { node } from "~/util/dom";

export default class GPSSwitch {
	_dom: {
		container: HTMLDivElement;
		button: HTMLButtonElement;
	};

	_visualizer: GPSSWitchVisualizer;

	constructor() {
		this._visualizer = new GPSSWitchVisualizer();

		this._dom = {
			container: node("div", { className: "module-content" }),
			// @ts-ignore
			button: node("button", { type: "button", className: "gps icon", innerHTML: `<span>${_("module.gps.title")}</span>` }),
		};

		this._dom.button.addEventListener("click", this, false);
		this._dom.container.appendChild(this._dom.button);
		this._dom.container.appendChild(this._visualizer.getContainer());
	}

	destroy() {
		this._dom.button.removeEventListener("click", this, false);
	}

	get container() {
		return this._dom.container;
	}

	set coords(coords) {
		this._visualizer.setCoords(coords);
	}

	set visualization(vis) {
		this._visualizer.setVisualization(vis);
	}

	handleEvent() {
		this._dom.container.classList.toggle("opened");
	}
}
